import React, { useCallback } from 'react';
import { getLogger } from '@nerdwallet/logging';
import LazyHydration from 'react-lazy-hydration';

const logger = getLogger('LazyHydrate');

interface Props {
  children: React.ReactElement;
}

const LazyHydrateWrapper: React.FC<Props> = ({ children }) => {
  logger.debug('HYDRATE', children[0]?.props?.value?.type);

  const handleDidHydrate = useCallback(() => {
    logger.debug(`Component (${children[0]?.props?.value?.type}) hydrated`);
  }, [children]);

  return (
    <LazyHydration didHydrate={handleDidHydrate} whenVisible noWrapper>
      {children}
    </LazyHydration>
  );
};

export default LazyHydrateWrapper;
